import { memo, ReactNode } from 'react';

import {
    AmplitudeExperimentsContextType,
    AmplitudeExperimentsProvider,
} from '@/components/AmplitudeExperimentsProvider/Context';

export const AmplitudeExperimentsClientProvider = memo(
    ({ children, client, deviceId, userId, variants }: AmplitudeExperimentsContextType & { children: ReactNode }) => {
        return (
            <AmplitudeExperimentsProvider
                client={client}
                deviceId={deviceId}
                userId={userId}
                variants={variants}
            >
                {children}
            </AmplitudeExperimentsProvider>
        );
    }
);
